import { render, staticRenderFns } from "./ContactFooter.vue?vue&type=template&id=dbea9dd8&"
import script from "./ContactFooter.vue?vue&type=script&lang=js&"
export * from "./ContactFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports